import comp from "./MoreItemWithToolTip";
export default comp;
